import React from 'react';
import { IIconProps, sizeMap } from './types';

export const POSIcon = ({ className, size = 'medium' }: IIconProps) => (
  <svg
    className={className}
    width={sizeMap[size].width}
    viewBox="0 0 22 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.1106 11.5387C10.2187 11.5366 9.29758 11.0681 8.16977 10.1996C7.77171 9.89305 7.21034 9.90445 6.83352 10.2367C5.00191 11.8519 3.63798 12.6321 1.75202 11.3087C0.535114 10.4548 0.34098 8.78096 0.885359 7.39759L3.02879 1.95072C3.25451 1.37712 3.80818 1 4.4246 1H11.1106"
      stroke="currentcolor"
      strokeWidth={sizeMap[size].strokeWidth}
    />
    <path
      d="M10.8894 11.5387C11.7813 11.5366 12.7024 11.0681 13.8302 10.1996C14.2283 9.89305 14.7897 9.90445 15.1665 10.2367C16.9981 11.8519 18.362 12.6321 20.248 11.3087C21.4649 10.4548 21.659 8.78096 21.1146 7.39759L18.9712 1.95072C18.7455 1.37712 18.1918 1 17.5754 1H10.8894"
      stroke="currentcolor"
      strokeWidth={sizeMap[size].strokeWidth}
    />
    <path
      d="M3.98867 11.8281V20.25M3.98867 20.25H1.76953H11.3643H3.98867Z"
      stroke="currentcolor"
      strokeWidth={sizeMap[size].strokeWidth}
    />
    <path
      d="M18.7398 11.8281V20.25M18.7398 20.25H20.959H11.3642H18.7398Z"
      stroke="currentcolor"
      strokeWidth={sizeMap[size].strokeWidth}
    />
  </svg>
);
